import {
  GetCersSubscription,
  GetSottoscrizioneTecnicoSubscription,
  GetSottoscrizioniTecnicoSubscription,
  Order_By,
  Sottoscrizione_Order_By,
} from '../../../../_core/_graphql/generated';

export type TecnicoState = {
  sottoscrizioni_loading: boolean;
  sottoscrizioni_data?: GetSottoscrizioniTecnicoSubscription['search_sottoscrizioni'];
  sottoscrizioni_filter: boolean;
  sottoscrizioni_filter_data: any;
  sottoscrizioni_page: number;
  sottoscrizioni_page_size: number;
  sottoscrizioni_total: number;
  sottoscrizioni_search: string;
  sottoscrizioni_active_filter: any;
  sottoscrizioni_order_by: Sottoscrizione_Order_By[];

  cabina_loading: boolean;
  cabina_data?: number[];

  selected_sottoscrizione_loading: boolean;
  selected_sottoscrizione?: GetSottoscrizioneTecnicoSubscription['sottoscrizione_by_pk'];

  cers_loading: boolean;
  cers_data?: GetCersSubscription['cer'];
  cers_filter: boolean;

  failure?: any;
};

export const initialTecnicoState: TecnicoState = {
  cabina_loading: false,
  cabina_data: undefined,

  sottoscrizioni_loading: true,
  sottoscrizioni_data: undefined,
  sottoscrizioni_filter: false,
  sottoscrizioni_filter_data: undefined,
  sottoscrizioni_page: 0,
  sottoscrizioni_page_size: 10,
  sottoscrizioni_total: 0,
  sottoscrizioni_search: '',
  sottoscrizioni_active_filter: undefined,
  sottoscrizioni_order_by: [{ updated_at: Order_By.Desc }],

  selected_sottoscrizione_loading: true,
  selected_sottoscrizione: undefined,

  cers_loading: false,
  cers_data: undefined,
  cers_filter: false,

  failure: undefined,
};
